import { useTranslation } from "react-i18next";
import UploadIcon from "../../icons/uploadIcon";
import { useState } from "react";

const FileInput = ({ id, formik, name }) => {
  const { t } = useTranslation();
  const [isDragging, setIsDragging] = useState(false);

  const allowedTypes = ["image/svg+xml", "image/png", "image/jpeg"];
  const maxSizeInBytes = 2 * 1024 * 1024; // 2MB

  const validateFile = (file) => {
    if (!allowedTypes.includes(file.type)) {
      alert(t("invalidFileType"));
      return false;
    }
    if (file.size > maxSizeInBytes) {
      alert(t("fileTooLarge"));
      return false;
    }
    return true;
  };

  const handleFile = (file) => {
    if (validateFile(file)) {
      formik.setFieldValue(name, file);
    }
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) handleFile(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) handleFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  return (
    <label
      htmlFor={id}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      className={`block p-4 my-3 border border-dashed cursor-pointer transition-colors min-h-[204px]
        ${
          isDragging
            ? "border-blue-500 bg-blue-50 dark:bg-gray-700"
            : "border-black dark:border-white dark:bg-gray-800"
        }`}
    >
      <UploadIcon className="mx-auto w-fit" />
      <h1 className="my-4 font-medium text-center dark:text-white">
        {t("dragOrClick")}
      </h1>
      <p className="text-center text-mainGray dark:text-gray-400">
        {t("maximumUploadLimit")}
      </p>
      <p className="text-center text-green-500 dark:text-green-400">
        {formik?.values?.[name]?.name}
      </p>
      <input
        type="file"
        id={id}
        name={id}
        onChange={handleChange}
        className="hidden"
        accept=".svg, .png, .jpg, .jpeg"
      />
    </label>
  );
};

export default FileInput;
